/* eslint-disable */
function a11() {
  return (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : []).filter(function (e) {
    return null != e
  })
}

export default a11
